<template>
  <v-dialog
    v-model="isActive"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :max-width="$vuetify.breakpoint.xsOnly ? '100%' : '700'"
    persistent
  >
    <v-card class="d-flex flex-column mobile-full-height">
      <!-- Header -->
      <div :class="[$vuetify.breakpoint.xsOnly ? 'mobile-header px-4' : 'pl-8 pr-8', 'pt-6 pb-0 lighten-3 font-weight-medium text-h5']">
        <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          @click="$emit('cancel')"
        >
          <v-icon size="32">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span>ข้อกำหนดและเงื่อนไขการให้บริการ</span>
      </div>

      <!-- Scrollable Content -->
      <div class="flex-grow-1 content-container scrollable-padding">
        <v-card-text
          class="scrollable-content overflow-content"
        >
          <div>
            <ul class="pd-0">
              <li class="margin-b-16">
                <b>1. การเปิดให้บริการ</b>
                <ul class="pd-16">
                  <li>
                    Sellsuki จะดำเนินการเปิดให้บริการตามคำสั่งซื้อของท่าน ภายในระยะเวลา 1-2 วันทำการ นับจากวันที่บริษัทได้รับยอดชำระครบถ้วน
                  </li>
                </ul>
              </li>

              <li class="margin-b-16">
                <b>2. การรับชำระเงิน</b>
                <ul class="pd-16">
                  <li class="margin-b-8">
                    Sellsuki รองรับการชำระเงินผ่านการโอนเงินผ่านบัญชีธนาคาร บัตรเครดิต/เดบิต และ QR Code PromptPay โดย <b>บริษัทรับชำระเฉพาะยอดชำระเต็มจำนวนเท่านั้น และทางบริษัทไม่รับผิดชอบค่าธรรมเนียมหรือค่าใช้จ่ายอื่นใดที่เกิดจากการชำระค่าบริการทั้งสิ้น</b>
                  </li>
                  <li>
                    กรุณาตรวจสอบค่าธรรมเนียมการโอนหรือค่าธรรมเนียมอื่นใดที่อาจถูกหักจากธนาคารหรือผู้ให้บริการก่อนทำรายการ <b>หากยอดเงินที่โอนเข้ามาไม่ครบถ้วนตามที่แจ้งไว้ บริษัทจะถือว่ารายการชำระเงินดังกล่าวยังไม่สมบูรณ์ และขอสงวนสิทธิ์ไม่ดำเนินการตามคำสั่งซื้อ</b>
                  </li>
                </ul>
              </li>

              <li class="margin-b-16">
                <b>3. การขอยกเลิกการชำระเงิน</b>
                <ul class="pd-16">
                  <li class="margin-b-8">
                    <b>3.1 กรณี Void</b>
                    <ul class="pd-16">
                      <li>
                        กรณีการชำระเงินผ่านบัตรเครดิต/เดบิต หรือ QR Code และลูกค้าประสงค์ยกเลิกการชำระเงิน (Void) บริษัทจะดำเนินการยกเลิกรายการชำระเงินภายใน 7 วันทำการ ทั้งนี้ ระยะเวลาในการคืนเงินอาจแตกต่างไปตามเงื่อนไขของธนาคารผู้ออกบัตรหรือผู้ให้บริการ
                      </li>
                    </ul>
                  </li>
                  <li class="margin-b-8">
                    <b>3.2 กรณี Refund</b>
                    <ul class="pd-16">
                      <li>
                        กรณีลูกค้าประสงค์ขอคืนเงิน (Refund) จากการชำระเงินผ่านบัตรเครดิต/เดบิต บริษัทขอสงวนสิทธิ์หักค่าธรรมเนียม 2% จากยอดชำระ โดยระบบจะดำเนินการคืนเงินภายในระยะเวลา 15-30 วันทำการ หรือเป็นไปตามเงื่อนไขของธนาคารผู้ออกบัตร
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li class="margin-b-16">
                <b>4. เครดิตเทอม (Credit Term)</b>
                <ul class="pd-16">
                  <li>
                    ทาง Sellsuki ไม่มีเครดิตเทอม (Credit Term) ระบบจะเปิดบริการตามคำสั่งซื้อหลังจากท่านได้ทำการชำระแล้วเท่านั้น
                  </li>
                </ul>
              </li>

              <li class="margin-b-16">
                <b>5. การนำส่งเอกสาร</b>
                <ul class="pd-16">
                  <li class="margin-b-8">
                    <b>5.1 ใบเสนอราคา (Quotation)</b>
                    <ul class="pd-16">
                      <li>
                        ทาง Sellsuki จะนำส่งเอกสารใบเสนอราคาให้ทางอีเมล
                      </li>
                    </ul>
                  </li>
                  <li class="margin-b-8">
                    <b>5.2 ใบแจ้งหนี้ (Invoice)</b>
                    <ul class="pd-16">
                      <li>
                        ท่านสามารถดาวน์โหลดใบแจ้งหนี้ได้จากหน้าเว็บไซต์ โดยเปิดใบเสนอราคา และเลือก “ใบแจ้งหนี้” และกด “พิมพ์” เพื่อบันทึกเอกสาร
                      </li>
                    </ul>
                  </li>
                  <li class="margin-b-8">
                    <b>5.3 ใบกำกับภาษี</b>
                    <ul class="pd-16">
                      <li>
                        ทาง Sellsuki จะนำส่งเอกสาร ใบเสร็จรับเงิน/ใบกำกับภาษี ในรูปแบบ E-Tax ผ่านทาง อีเมลเท่านั้น หรือท่านสามารถดาวน์โหลดได้ด้วยตนเองที่เมนู รายการสั่งซื้อ ได้จากหน้าเว็บไซต์
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>5.4 หนังสือรับรองการหักภาษี ณ ที่จ่าย</b>
                    <ul class="pd-16">
                      <li>
                        <b>หากท่านสั่งซื้อในนามนิติบุคคล และไม่ได้แต่งตั้ง Sellsuki เป็นตัวแทนหักและนำส่งภาษี ณ ที่จ่าย ท่านจำเป็นต้องนำส่ง “หนังสือรับรองการหักภาษี ณ ที่จ่าย” ให้กับทาง Sellsuki</b><br>
                        ตามที่อยู่ต่อไปนี้<br>
                        บริษัท เซลสุกิ จำกัด (ทีมบัญชี)<br>
                        10/39 ชั้นที่ 3 ถนนรัชดาภิเษก แขวงจันทรเกษม เขตจตุจักร กรุงเทพฯ 10900
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li class="margin-b-16">
                <b>6. ข้อกำหนดการใช้งาน</b>
                <ul class="pd-16">
                  <li>
                    ขอสงวนสิทธิ์ในการคืนเงินสำหรับลูกค้าที่ใช้บัญชี LINE Official Account ที่ผิดต่อข้อบังคับของบริษัท LY Corporation ในทุกกรณี สามารถดูเพิ่มเติมได้ที่
                    <a
                      href="http://terms.line.me/line_terms"
                      target="_blank"
                    >
                      http://terms.line.me/line_terms
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข หรือปรับปรุงข้อกำหนดและเงื่อนไขการให้บริการ โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
              </li>
              <li>
                <br>
                หากมีข้อสงสัยเกี่ยวกับการชำระเงิน สามารถติดต่อทีมงานภายใน วันและเวลาทำการได้ที่
                <br>
                <br>
                LINE Official Account: @linebysellsuki<br>
                อีเมล: lineagency@sellsuki.com<br>
                เบอร์โทร: 02-026-3250 ต่อ 1 และ ต่อ 1 หรือ 2
              </li>
            </ul>
          </div>
        </v-card-text>
      </div>

      <!-- Fixed Bottom Section -->
      <div class="fixed-bottom">
        <v-card-text class="pb-0 pt-0 px-4 pl-6 d-none d-sm-block">
          <v-checkbox
            v-model="agree"
            class="mt-0 pb-0 pt-0"
            label="ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขในการให้บริการนี้"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 d-none d-sm-block">
          <div class="actions-container">
            <v-btn
              color="btn-close"
              rounded
              :min-width="$vuetify.breakpoint.xsOnly ? '120' : '150'"
              exact
              @click="$emit('cancel')">
              ปิด
            </v-btn>
            <v-btn
              class="ml-4"
              color="primary"
              rounded
              :min-width="$vuetify.breakpoint.xsOnly ? '120' : '150'"
              :disabled="!agree"
              style="letter-spacing: normal"
              @click="$emit('accept')">
              ยอมรับ
            </v-btn>
          </div>
        </v-card-actions>

        <v-card-text class="pb-0 pt-4 px-4 pl-4 d-block d-sm-none">
          <v-checkbox
            v-model="agree"
            class="mt-0 pb-0 pt-0"
            label="ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขในการให้บริการนี้"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="px-4 pt-0 pb-4 d-block d-sm-none">
          <div class="actions-container">
            <v-btn
              class="ml-4 py-4 h-"
              color="primary"
              rounded
              min-width="100%"
              :disabled="!agree"
              style="font-size: 20px;letter-spacing: normal;height: 50px;"
              @click="$emit('accept')">
              ยอมรับ
            </v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderPrivacyPolicy',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agree: false
    }
  },
  computed: {
    isActive: {
      get() {
        return this.active
      },
      set(val) {
        this.$emit('update:active', val)
      }
    }
  }
}
</script>

<style scoped>
li {
  list-style-type: none;
}

li ul li::marker {
    font-size: 9px; /* หรือเป็น px เช่น 12px */
}

.margin-b-24 {
  margin-bottom: 24px;
}

.margin-b-16 {
  margin-bottom: 16px;
}

.margin-b-8 {
  margin-bottom: 8px;
}

.pd-16 {
  padding-left: 16px;
}

.pd-0 {
  padding-left: 0px;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.btn-close {
  background: #E5E7EB !important;
  border: none !important;
  color: #666666;
  letter-spacing: 0 !important;
}

.v-btn:before {
  letter-spacing: 0 !important;
}

.v-btn--is-elevated {
  box-shadow: none;
}

.v-card__subtitle, .v-card__text {
  font-size: 16px;
}

.theme--light.v-card {
  color: #000000;
}

@media (max-width: 600px) {
  .mobile-full-height {
    height: 100vh !important;
  }

  .content-container {
    position: relative;
    height: calc(100vh - 200px); /* ปรับความสูงให้เหลือพื้นที่สำหรับ header และ bottom section */
    overflow: hidden;
    margin-top: 16px;
  }

  .scrollable-content {
    height: 100%;
    overflow-y: auto;
    padding: 16px;
  }

  .fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
  }

  .actions-container {
    padding: 0;
  }

  /* ปรับขนาดฟอนต์สำหรับ mobile */
  .text-h5 {
    font-size: 1.25rem !important;
  }

  .overflow-content {
    max-height: 100%;
    overflow-y: auto;
  }

  .scrollable-padding {
    padding: 0;
    margin-top: 0px;
    padding-bottom: 145px;
  }

  .mobile-header {
    padding: 28px !important;
    display: flex;
    align-items: center;
    position: relative;
    background: #FFF;
  }

  .mobile-header span {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    width: 70%; /* ปรับความกว้างของ text ให้ไม่ทับกับปุ่ม */
    text-align: center;
    font-size: 18px !important
  }

  .mobile-header .v-btn {
    position: fixed;
    left: 8px;
  }
}
@media (min-width: 600px) {
  .overflow-content {
    max-height: 400px; overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
  }
  .scrollable-padding {
    padding: 24px 28px 24px 28px;
  }
}</style>
